import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { serverInfo } from "../../../../../App";

export default function OnlineUser({ user }) {
  const { imageCdnUrl } = useContext(serverInfo);

  const [userInfo, setUserInfo] = useState([]);
console.log('onlineuser',user);
  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`api/user_info/${user}`).then((res) => {
        if (res.data.status === 200) {
          setUserInfo(res.data.users);
        }
      });
  }, []);

  return (
    <>
      <div className="accordion-header chatListname" id="headingTwo">
        <div className="d-flex">
          <div className="containerOnline">
            <img
              src={userInfo.image==null ? 'https://d35vkepp4dfq5y.cloudfront.net/demo/demo_user.png': imageCdnUrl + userInfo.image}
              className="SidebarStarListImage"
              alt=""
            />

            <div className="onLineMo">🟢</div>
          </div>
          <div className="col-md-9  mt-2">
            <div className="chatName">
              {userInfo?.first_name} {userInfo?.last_name}
            </div>
          </div>
        </div>

        <span></span>
      </div>
    </>
  );
}
